// src/content/progressbars/ProgressBarCourses.jsx
import React from 'react';
import './ProgressBarCourses.css';

export const ProgressBarCourses = ({ progress }) => {
  return (
    <div className="progress-bar-course-container">
      <div className="progress-bar-course-track">
        <div
          className="progress-bar-course-fill"
          style={{ width: `${progress}%` }}
        ></div>
      </div>

    </div>
  );
};
